import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

let scene, camera, renderer, controls, model, container;

window.loadGLB = function(url) {
  container = document.getElementById('viewer');

  // Keyboard navigation for accessibility
  container.addEventListener('keydown', (event) => {
    switch (event.key) {
      case 'ArrowLeft':
        controls.rotateLeft(0.1);
        break;
      case 'ArrowRight':
        controls.rotateLeft(-0.1);
        break;
      case 'ArrowUp':
        controls.rotateUp(0.1);
        break;
      case 'ArrowDown':
        controls.rotateUp(-0.1);
        break;
      case '+':
      case '=':
        controls.dollyIn(1.1);
        break;
      case '-':
      case '_':
        controls.dollyOut(1.1);
        break;
      default:
        return; // Do nothing for other keys
    }
    controls.update();
    event.preventDefault();
  });

  if (!container) {
    console.error('No #viewer container found!');
    return;
  }
  if (renderer && renderer.domElement.parentNode === container) {
    container.removeChild(renderer.domElement);
  }
  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xffffff);

  const isMobile = window.innerWidth < 600;
  camera = new THREE.PerspectiveCamera(
    isMobile ? 60 : 45,
    container.offsetWidth / container.offsetHeight,
    0.1,
    1000
  );
  camera.position.set(0, 2, 6);

  renderer = new THREE.WebGLRenderer({ antialias: !isMobile });
  renderer.setSize(container.offsetWidth, container.offsetHeight);
  renderer.setPixelRatio(isMobile ? 1 : Math.min(window.devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
  container.appendChild(renderer.domElement);
  renderer.domElement.tabIndex = 0;

  // Create controls
  controls = new OrbitControls(camera, renderer.domElement);

  // Touch/mouse settings
  controls.enableDamping = true;
  controls.dampingFactor = 0.08;
  controls.screenSpacePanning = true;
  controls.enableZoom = true;
  controls.zoomSpeed = 0.8;
  controls.enablePan = true;
  controls.panSpeed = 0.8;

  // Disable pan on mobile
  if (isMobile) controls.enablePan = false;

  controls.minDistance = 1;
  controls.maxDistance = 100;
  controls.target.set(0, 0, 0);
  controls.update();

  // Store lights in variables so we can adjust them later
  const ambientLight = new THREE.AmbientLight(0xffffff, 3.5);
  scene.add(ambientLight);

  const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 2.2);
  hemiLight.position.set(0, 20, 0);
  scene.add(hemiLight);

  const dirLight = new THREE.DirectionalLight(0xffffff, 2.2);
  dirLight.castShadow = true;
  scene.add(dirLight);

  const fillLight = new THREE.DirectionalLight(0xffffff, 1.2);
  fillLight.position.set(-5, -2, -7.5);
  scene.add(fillLight);

  const backLight = new THREE.DirectionalLight(0xffffff, 1.2);
  backLight.position.set(0, -10, -10);
  scene.add(backLight);

  const upLight = new THREE.DirectionalLight(0xffffff, 1.0); // Adjust intensity as needed
  upLight.position.set(0, -5, 0); // Below the model
  upLight.target.position.set(0, 0, 0); // Point at the center
  scene.add(upLight);
  scene.add(upLight.target);

  dirLight.target.position.set(0, 0, 0);
  scene.add(dirLight.target);

  // Create a light that will follow the camera
  const cameraLight = new THREE.DirectionalLight(0xffffff, 1.5);
  scene.add(cameraLight);

  if (model) {
    scene.remove(model);
    model = null;
  }

  const loader = new GLTFLoader();
  loader.load(url, function(gltf) {
    model = gltf.scene
    const box = new THREE.Box3().setFromObject(model);
    const size = box.getSize(new THREE.Vector3()).length();
    const center = box.getCenter(new THREE.Vector3());
    model.position.x -= center.x;
    model.position.y -= (box.min.y + box.max.y) / 2;
    model.position.y += (box.max.y - box.min.y) * 0.05;
    model.position.z -= center.z;
    const scale = 5 / size;
    model.scale.setScalar(scale);

    // Only adjust these torso models upward and adjust lighting/materials
    const torsoModels = ['model3', 'model5', 'model6', 'model8', 'model13', 'model20', 'model25'];
    const legModels = ['model10', 'model22', 'model28'];
    let isSpecial = false;

    if (torsoModels.some(slug => url.includes(slug))) {
      model.position.y += 2.5; // torso models
      // Adjust lighting for torso models
      ambientLight.intensity = 2.2;
      hemiLight.intensity = 1.5;
      dirLight.intensity = 1.5;
      fillLight.intensity = 0.8;
      backLight.intensity = 0.8;
      isSpecial = true;

      // Hide underwear meshes by material name (for torso models)
      model.traverse((child) => {
        if (
          child.isMesh &&
          child.material &&
          typeof child.material.name === 'string' &&
          child.material.name.toLowerCase().includes('underwear')
        ) {
          child.visible = false;
        }
      });
    } else if (legModels.some(slug => url.includes(slug))) {
      model.position.y += 1.2; // less upward for model10
      // Adjust lighting for leg model
      ambientLight.intensity = 2.2;
      hemiLight.intensity = 1.5;
      dirLight.intensity = 1.5;
      fillLight.intensity = 0.8;
      backLight.intensity = 0.8;
      isSpecial = true;
    }

    if (!isSpecial) {
      ambientLight.intensity = 3.5;
      hemiLight.intensity = 2.2;
      dirLight.intensity = 2.2;
      fillLight.intensity = 1.2;
      backLight.intensity = 1.2;
    }

    scene.add(model);

    // HIDE SPINNER HERE:
    var spinner = document.getElementById('spinner');
    if (spinner) spinner.style.display = 'none';
  }, undefined, function(error) {
    console.error('Failed to load 3D model:', error);
    container.innerHTML = 'Failed to load 3D model.';

    const spinner = document.getElementById('spinner');
    if (spinner) spinner.style.display = 'none';
  });

  function animate() {
    requestAnimationFrame(animate);
    controls.update();

    // Make the light follow the camera's position and direction
    cameraLight.position.copy(camera.position);
    const cameraDirection = new THREE.Vector3();
    camera.getWorldDirection(cameraDirection);
    cameraLight.target.position.copy(
      camera.position.clone().add(cameraDirection)
    );

    renderer.render(scene, camera);
  }
  animate();

  window.addEventListener('resize', () => {
    if (!renderer || !camera) return;
    camera.aspect = container.offsetWidth / container.offsetHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(container.offsetWidth, container.offsetHeight);
  });
};

const loadBtn = document.getElementById('loadModelBtn');
if (loadBtn) {
  loadBtn.addEventListener('click', () => {
    loadBtn.style.display = 'none';
    if (window.defaultGLBPath) {
      window.loadGLB(window.defaultGLBPath);
    }
  });
} else {
  // Fallback: load immediately if button not present
  if (window.defaultGLBPath) {
    window.loadGLB(window.defaultGLBPath);
  }
}